import React from 'react';
import { FormControl, InputLabel, Select } from '@mui/material';

export default function SmtpTlsSelect({ value, onChange }) {
  return (
    <FormControl fullWidth margin="dense">
      <InputLabel>Connection protection</InputLabel>
      <Select
        native
        value={value}
        label="Connection protection"
        onChange={onChange}
      >
        <option value="SSL/TLS">SSL/TLS</option>
        <option value="STARTTLS">STARTTLS</option>
        <option value="None">None</option>
      </Select>
    </FormControl>
  );
}
